const Home = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1352 4.03954C12.0573 3.98682 11.9427 3.98682 11.8648 4.03953L4.06476 9.31439C4.01188 9.35016 4 9.39214 4 9.41605V19.2882C4 19.6346 4.31023 20 4.8 20H8V14.1528C8 12.9235 9.03292 12.0116 10.2 12.0116H13.8C14.9671 12.0116 16 12.9235 16 14.1528V20H19.2C19.6898 20 20 19.6346 20 19.2882V9.41605C20 9.39214 19.9881 9.35016 19.9352 9.31439L12.1352 4.03954ZM19.2 22C20.6985 22 22 20.8326 22 19.2882V9.41605C22 8.70116 21.6358 8.05005 21.0556 7.65767L13.2556 2.38281C12.5009 1.8724 11.4991 1.8724 10.7444 2.38281L2.94438 7.65767C2.36416 8.05005 2 8.70117 2 9.41605V19.2882C2 20.8326 3.30155 22 4.8 22H19.2ZM14 20V14.1528C14 14.1305 13.9922 14.1017 13.9594 14.0705C13.9257 14.0385 13.8716 14.0116 13.8 14.0116H10.2C10.1284 14.0116 10.0743 14.0385 10.0406 14.0705C10.0078 14.1017 10 14.1305 10 14.1528V20H14Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Home;
